import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/eventSubmissionStore';
import Layout from '../layout/Layout';
import AppContainer from 'containers/AppContainer';
import SecureCheckoutPage from 'containers/SecureCheckoutPage';
import { StripeProvider } from 'react-stripe-elements';
import styles from './OneStepCheckout.scss';

import PublisherCheckoutWizard from 'containers/PublisherCheckoutWizardContainer';


const PublisherCheckout = (props) => (
  <Provider store={configureStore(props)}>
    <Layout>
      <AppContainer>
        <StripeProvider apiKey={props.stripe_key}>
          <PublisherCheckoutWizard className={styles.oneStepCheckout}/>
        </StripeProvider>
      </AppContainer>
    </Layout>
  </Provider>
);

export default PublisherCheckout;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/startup/PublisherCheckout.jsx